import Dispatcher from '../dispatcher/CentricDispatcher.react.js';
import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';
import { ActionTypes } from '../constants/CentricConstants';

class UserSkillStore extends ReduceStore {
    getInitialState() {
        return Map();
    }
    
    get(key) {
        return this.getState().get(key);
    }

    getCurrent(key) {
        const list = this.get(key);
        const now = new Date();
        return list && list.filter(({dateExpired}) => !dateExpired || now < new Date(dateExpired));
    }

    getBySkillId(key, skillId) {
        const list = this.get(key);
        const now = new Date();
        return list && list.find((e) => !!e && e.skillId === skillId && (!e.dateExpired || now < new Date(e.dateExpired)));
    }

    reduce(state, action) {
        let userSkills;
        switch (action.type) {
            case ActionTypes.USER_SKILL_LIST:
                const skillList = action.data.map((entry) => {
                    if (!!entry.dateExpired) {
                        entry.dateExpiredObject = new Date(entry.dateExpired);
                    }
                    return entry;
                });
                return state.set(action.payload.userId, skillList);

            case ActionTypes.USER_SKILL_INFO_SUCCESS:
                return state.set(action.payload.userId, [
                    ...(this.getState().get(action.payload.userId) || []).filter(({skillId}) => skillId !== action.data.skillId),
                    action.data
                ]);

            case ActionTypes.USER_SKILL_SAVE:
                userSkills = this.getState().get(action.payload.userId).slice(0);
                userSkills.push(action.data);
                return state.set(action.payload.userId, userSkills);

            case ActionTypes.USER_SKILL_UPDATE_SUCCESS:
                return state.set(action.payload.userId, (this.get(action.payload.userId) || []).map((skill) => skill.skillId === action.payload.skillId ? action.data : skill));

            case ActionTypes.USER_SKILL_REMOVE_SUCCESS:
                return state.set(action.payload.userId, this.getState().get(action.payload.userId).filter(({skillId}) => skillId !== action.payload.skillId));

            default:
                return state;
        }
    }
}

export default new UserSkillStore(Dispatcher);
